import React, { useContext } from 'react';
import { UserConst } from '@axiom/const';
import { PageContext } from '@axiom/ui';

import { MyEngagementsRedirectClientUser } from '../components/MyEngagements/MyEngagementsRedirectClientUser';
import { MyAxiomAuthRouter } from '../routes/MyAxiomAuthRouter';
import { AuthRoute } from '../routes/AuthRoute';

export const MyAxiomPage = () => {
  const { setTitle } = useContext(PageContext);
  setTitle('AxiomLaw - My Axiom');
  return (
    <MyAxiomAuthRouter>
      <AuthRoute
        name="AUTH_ROUTE"
        roles={[
          UserConst.Roles.ClientUser,
          UserConst.Roles.EnvoyAdmin,
          UserConst.Roles.EnvoyUser,
          UserConst.Roles.EnvoySales,
        ]}
      >
        <MyEngagementsRedirectClientUser />
      </AuthRoute>
    </MyAxiomAuthRouter>
  );
};
